<template>
  <div>
    <ClientConclusionFunctionalForm
        v-if="showForm"
        :establishment="establishment"
        :functionals="functionals"
        v-on:submit="submitForm"
        v-on:delete="deleteItem"
        v-on:cancel="closeForm"/>

    <div class="mb-5">
      <div class="py-3 px-4 border bg-light font-weight-bold text-secondary position-relative">
        Функциональные состояния

        <div class="position-absolute"  style="right:10px;top:8px;">
          <button
              class="btn btn-primary"
              @click="showForm = true">
            Новое функциональное состояния
          </button>
        </div>
      </div>

      <ClientConclusionFunctionalList
          v-on:select="selectEstablishment"
          :items="current" />

      <div
          @click="showPast =! showPast"
          class="py-3 px-4 border-left border-right border-bottom bg-light font-weight-bold text-secondary pointer">
        <u>История функциональных состояний</u>
      </div>

      <ClientConclusionFunctionalList
          v-if="showPast"
          v-on:select="selectEstablishment"
          :items="past" />
    </div>
  </div>
</template>

<script>
import ClientConclusionFunctionalList from './functional/List';
import ClientConclusionFunctionalForm from './functional/Form';
import formatDate from '../../../utils/formatDate';

export default {
  name: 'ClientConclusionFunctionals',

  components: {ClientConclusionFunctionalList, ClientConclusionFunctionalForm},

  props: ['functionals', 'establishments', 'submitFunctionalEstablishment', 'deleteFunctionalEstablishment'],

  data() {
    return {
      showPast: false,
      establishmentId: null,
      showForm: false,
    };
  },

  computed: {
    data() {
      const data = this.establishments.map(e => {
        const {id, note, createdBy} = e;
        const dateFrom = new Date(e.dateFrom);
        const dateTo = typeof e.dateTo === 'string' && e.dateTo.trim() !== '' ? new Date(e.dateTo) : '';
        const functional = this.functionals.find(f => f.id === e.functional);

        return {id, dateFrom, dateTo, note, functional, createdBy};
      });

      data.sort((a, b) => b.dateFrom.getTime() - a.dateFrom.getTime());

      return data;
    },

    past() {
      return this.data.filter(i => i.dateTo instanceof Date);
    },

    current() {
      return this.data.filter(i => !(i.dateTo instanceof Date));
    },

    establishment() {
      return this.establishments.find(i => i.id === this.establishmentId);
    },
  },

  methods: {
    selectEstablishment(id) {
      this.showForm = true;
      this.establishmentId = id;
    },

    closeForm() {
      this.showForm = false;
      this.establishmentId = null;
    },

    formatDate(date, format) {
      return formatDate(date, format);
    },

    async submitForm(data) {
      await this.submitFunctionalEstablishment(data);

      this.closeForm();
    },

    async deleteItem(id) {
      await this.deleteFunctionalEstablishment(id);

      this.closeForm();
    },
  },
};
</script>
